export type EasingName = 'linear' | 'ease-in' | 'ease-out' | 'ease-in-out';

export const EASING_OPTIONS: { value: EasingName; label: string }[] = [
  { value: 'linear', label: 'Linear' },
  { value: 'ease-in', label: 'Ease in' },
  { value: 'ease-out', label: 'Ease out' },
  { value: 'ease-in-out', label: 'Ease in and out' },
];

export function clamp01(t: number): number {
  return t < 0 ? 0 : t > 1 ? 1 : t;
}

/** Cubic easing curves; input and output are clamped to 0..1. Unknown names are linear. */
export function ease(name: unknown, t: number): number {
  const x = clamp01(t);
  switch (name) {
    case 'ease-in':
      return x * x * x;
    case 'ease-out': {
      const inv = 1 - x;
      return 1 - inv * inv * inv;
    }
    case 'ease-in-out': {
      if (x < 0.5) return 4 * x * x * x;
      const inv = -2 * x + 2;
      return 1 - (inv * inv * inv) / 2;
    }
    default:
      return x;
  }
}
